// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import CustomerListResultModel from '../../model/customer-list-result-model';
import CustomerListResultDTO from '../dto/customer-list-result-dto';
import CustomerModel from '../../model/customer-model';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class CustomerListResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<CustomerListResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => CustomerModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
    }
  }
  /**
  */
  'items'?: CustomerModel[];
  /**
  */
  'links'?: ResourceLinkModel[];

  static toModel(dto: DeepPartial<CustomerListResultDTO>): CustomerListResultModel;
  static toModel(dto: DeepPartial<CustomerListResultDTO> | undefined | null): CustomerListResultModel | undefined;
  static toModel(dto: DeepPartial<CustomerListResultDTO> | undefined | null): CustomerListResultModel | undefined {
    return dto ? new CustomerListResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<CustomerListResultModel> | CustomerListResultModel) {
    const unwrapped = unwrapDataRecord(model);
    return {
      'items': unwrapped.items,
      'links': unwrapped.links,
    } as CustomerListResultDTO;
  }
}
